import { extends as _extends } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Brandy from '../../Brandy/index.js';
import Price from '../../Price/index.js';
import { PackageCard, Grid, Column, CustomTextContainer, CustomText } from './HorizontalPackageCard.styles.js';
import Label from '../Labelv2/Label.js';
import NameAndDescription from '../NameAndDescription/NameAndDescription.js';
import Details from '../Details/Details.js';
import MainContent from '../MainContent/MainContent.js';
import Bullets from '../Bullets/Bullets.js';

var HorizontalPackageCard = function HorizontalPackageCard(_ref) {
  var _image$props, _ref2, _packageData$price, _packageData$price2, _packageData$price3, _packageData$price4, _packageData$price5, _packageData$price6;
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$labelData = _ref.labelData,
    labelData = _ref$labelData === void 0 ? null : _ref$labelData,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? null : _ref$modal,
    packageData = _ref.packageData;
  var hasImage = Boolean(image === null || image === void 0 || (_image$props = image.props) === null || _image$props === void 0 ? void 0 : _image$props.data);
  var numberOfColumns = ((_ref2 = [Boolean(packageData === null || packageData === void 0 ? void 0 : packageData.bullets), hasImage]) === null || _ref2 === void 0 || (_ref2 = _ref2.filter(Boolean)) === null || _ref2 === void 0 ? void 0 : _ref2.length) + 1;
  return /*#__PURE__*/React__default.createElement(PackageCard, {
    className: "wrapper",
    numberOfColumns: numberOfColumns,
    hasImage: hasImage // Change the grid on tablet since we're hiding image on tablet
  }, (labelData === null || labelData === void 0 ? void 0 : labelData.text) && /*#__PURE__*/React__default.createElement(Label, {
    text: labelData.text,
    labelType: "contentfulLabel",
    smallSpacing: true,
    noPositionStyles: true
  }), /*#__PURE__*/React__default.createElement(Grid, {
    numberOfColumns: numberOfColumns,
    hasImage: hasImage
  }, /*#__PURE__*/React__default.createElement(Column, {
    className: "column-1"
  }, /*#__PURE__*/React__default.createElement(NameAndDescription, {
    name: packageData.name,
    description: packageData.description
  }), /*#__PURE__*/React__default.createElement(Details, {
    packageData: packageData.details
  }), (packageData === null || packageData === void 0 || (_packageData$price = packageData.price) === null || _packageData$price === void 0 ? void 0 : _packageData$price.amount) && /*#__PURE__*/React__default.createElement(Price, _extends({
    className: "price"
  }, packageData === null || packageData === void 0 ? void 0 : packageData.price, {
    inPackageCard: true,
    priceOld: packageData === null || packageData === void 0 ? void 0 : packageData.priceOld,
    nutrition: packageData === null || packageData === void 0 ? void 0 : packageData.nutrition
  })), (packageData === null || packageData === void 0 || (_packageData$price2 = packageData.price) === null || _packageData$price2 === void 0 ? void 0 : _packageData$price2.custom) && /*#__PURE__*/React__default.createElement(CustomTextContainer, null, /*#__PURE__*/React__default.createElement(CustomText, {
    inPackageCard: true
  }, packageData === null || packageData === void 0 || (_packageData$price3 = packageData.price) === null || _packageData$price3 === void 0 ? void 0 : _packageData$price3.custom), (packageData === null || packageData === void 0 || (_packageData$price4 = packageData.price) === null || _packageData$price4 === void 0 ? void 0 : _packageData$price4.disclaimer) && /*#__PURE__*/React__default.createElement(Brandy, {
    className: "bullet-disclaimer",
    symbol: (_packageData$price5 = packageData.price) === null || _packageData$price5 === void 0 || (_packageData$price5 = _packageData$price5.disclaimer) === null || _packageData$price5 === void 0 ? void 0 : _packageData$price5.symbol,
    text: (_packageData$price6 = packageData.price) === null || _packageData$price6 === void 0 || (_packageData$price6 = _packageData$price6.disclaimer) === null || _packageData$price6 === void 0 ? void 0 : _packageData$price6.text,
    variant: "legal"
  })), modal && /*#__PURE__*/React__default.createElement("span", {
    className: "modal"
  }, modal), /*#__PURE__*/React__default.createElement(MainContent, {
    content: content
  })), Boolean(packageData === null || packageData === void 0 ? void 0 : packageData.bullets) && /*#__PURE__*/React__default.createElement(Column, {
    className: "column-2"
  }, /*#__PURE__*/React__default.createElement(Bullets, {
    bullets: packageData === null || packageData === void 0 ? void 0 : packageData.bullets
  })), hasImage && /*#__PURE__*/React__default.createElement(Column, {
    className: "column-3"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "desktop-image"
  }, image))), ' ');
};

/* eslint-enable react/no-danger */
var HorizontalPackageCard$1 = HorizontalPackageCard;

export { HorizontalPackageCard$1 as default };
//# sourceMappingURL=HorizontalPackageCard.js.map
